module.exports = __webpack_public_path__ + "static/media/19ESCAP11.80e337bc.jpg";